<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.actId" placeholder="EventID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.inviteCode" placeholder="Invitation"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="UserID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.name" placeholder="Name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.email" placeholder="Email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.phone" placeholder="Phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.paid" placeholder="Paid/Unpaid" clearable>
            <el-option value="true" label="Paid" />
            <el-option value="false" label="Unpaid" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">Search</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <el-table
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column prop="id" label="Number"></el-table-column>

      <!-- <el-table-column prop="inviteUserId" label="用户ID"></el-table-column> -->

      <el-table-column prop="actId" label="EventID"></el-table-column>

      <el-table-column prop="name" label="Name"></el-table-column>

      <el-table-column prop="phone" label="Phone"></el-table-column>

      <!-- <el-table-column prop="product" label="商品"></el-table-column> -->

      <el-table-column prop="size" label="Size"></el-table-column>

      <!-- <el-table-column prop="color" label="颜色"></el-table-column> -->

      <!-- <el-table-column prop="price" label="价格"></el-table-column> -->

      <el-table-column prop="email" label="Email"></el-table-column>

      <el-table-column prop="address" label="Address"></el-table-column>

      <el-table-column prop="paid" label="Paid?">
        <template slot-scope="scope">{{ scope.row.paid ? "已支付" : "未支付" }}</template>
      </el-table-column>

      <el-table-column prop="payTime" label="PayTime">
        <template #default="{ row }">
          <span v-if="row.payTime.Valid">{{ row.payTime.Time | formatDate }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="payReference" label="Reference Number"></el-table-column> -->

      <!-- <el-table-column prop="payScreenshot" label="Screenshot">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.payScreenshot"
            :src="scope.row.payScreenshot"
            :preview-src-list="[scope.row.payScreenshot]"
            style="width: 50px; height: 50px"
            fit="cover"
          />
        </template>
      </el-table-column> -->

      <el-table-column prop="createTime" label="Time">
        <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
      </el-table-column>

      <!-- <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="80px">
        <el-form-item label="inviteUserId">
          <el-input v-model="addForm.inviteUserId"></el-input>
        </el-form-item>

        <el-form-item label="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>

        <el-form-item label="phone">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>

        <el-form-item label="size">
          <el-input v-model="addForm.size"></el-input>
        </el-form-item>

        <el-form-item label="email">
          <el-input v-model="addForm.email"></el-input>
        </el-form-item>

        <el-form-item label="createTime">
          <el-input v-model="addForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="姓名">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>

        <el-form-item label="电话">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>

        <el-form-item label="尺码">
          <el-input v-model="editForm.size"></el-input>
        </el-form-item>

        <el-form-item label="邮件">
          <el-input v-model="editForm.email"></el-input>
        </el-form-item>

        <el-form-item label="用户ID">
          <el-input v-model="editForm.inviteUserId"></el-input>
        </el-form-item>

        <el-form-item label="createTime">
          <el-input v-model="editForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
export default {
  name: "ActInvite",
  components: { MyPagination },
  data() {
    return {
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/act-invite/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.addForm = {
        name: "",
        description: "",
      };
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        await this.axios.post("base:/api/admin/act-invite/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("base:/api/admin/act-invite/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        await this.axios.post("base:/api/admin/act-invite/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
